var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPricingArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.0549 20.4786C38.7817 15.7735 38.2241 11.1004 34.1991 8.06472C30.9422 5.6083 26.6377 4.79096 22.6543 4.51518C19.8383 4.32023 16.9287 4.3584 14.1294 4.76484C12.8403 4.95203 11.8521 6.5418 13.7155 6.27126C20.5764 5.27503 31.9287 5.51621 34.9383 13.1733C37.6371 20.0393 33.4538 29.2021 29.601 34.8143C27.9621 37.2017 26.0536 39.5295 23.9018 41.5493C24.3849 39.8653 24.8679 38.1814 25.351 36.4974C25.7418 35.1351 23.2913 34.0422 22.8323 35.6425C21.9459 38.7323 21.0595 41.8222 20.1731 44.9121C19.9275 45.7681 21.0884 46.799 21.9047 46.5828C25.0117 45.7598 28.1187 44.9369 31.2257 44.1139C32.8353 43.6875 31.6575 41.2627 30.2813 41.6273C28.5353 42.0898 26.7894 42.5522 25.0434 43.0147C31.7251 37.4194 36.7442 28.9637 38.0549 20.4786Z",
    fill: "#EDAB40"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPricingArrow);
export default __webpack_public_path__ + "static/media/pricingArrow.482a593a1253734ed3cceb416eb0898d.svg";
export { ForwardRef as ReactComponent };